/* 
 *  Created by SGiri 03/19/2018
 */

import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectedReport } from '~admin/model/SelectedReport';
import { AdminService } from '~admin/services/admin.service';
import { CommonService } from '~util/common.service';


@Component({
  selector: 'app-action-dialog',
  templateUrl: './action-dialog.component.html',
  styleUrls: ['./action-dialog.component.css']
})
export class ActionDialogComponent implements OnInit {

  isRollback: boolean;
  request: any;
  selectedReports: SelectedReport[];
  params: any;

  constructor(public dialogRef: MatDialogRef<ActionDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private service: AdminService, private commonService: CommonService) { }

  ngOnInit() {

    if (this.data.action === 'view') {
      this.isRollback = false;
    } else if (this.data.action === 'request') {
      this.request = false;
      this.selectedReports = this.data.params;
    } else {
      this.isRollback = true;
    }
    this.params = this.data.params;
    this.request = this.params.data;

  }

  rollback() {

    this.data.params.api.gridCore.gridOptions.api.showLoadingOverlay();

    this.service.rollback(this.request).subscribe(() => {
      this.commonService.reload();
      this.dialogRef.close();
    }, (error) => {
      this.dialogRef.close();
      let data = {
        isError: true,
        message: 'Request to rollback this request was unsuccessful.  Contact support.'
      }
      this.params.api.gridCore.gridOptions.api.hideOverlay();
      this.commonService.showDialog(data);
    });
  }

  process() {

    //this.data.params.api.gridCore.gridOptions.api.showLoadingOverlay();

    this.service.process({
      sourceEnvironment: this.data.params[0].sourceEnvironment,
      targetEnvironment: this.data.params[0].targetEnvironment,
      requestDetails: this.data.params
    }).subscribe(() => {

      this.dialogRef.close();
      let data = {
        isError: false,
        header: 'Information',
        message: 'Request successful!'
      }
      //this.params.api.gridCore.gridOptions.api.hideOverlay();
      this.commonService.showDialog(data);
      //this.commonService.reload();
    }, (error) => {
      this.dialogRef.close();
      let data = {
        isError: true,
        message: 'Request to create was unsuccessful.  Contact support.'
      }
      //this.params.api.gridCore.gridOptions.api.hideOverlay();
      this.commonService.showDialog(data);
    });
  }

  cancel() {
    this.dialogRef.close(true);
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-admin/action-dialog/action-dialog.component.ts